import { Component } from '@angular/core';
import { ThemeService } from './services/theme.service';
import { AppThemes } from './types/enums/app-theme.enum';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'angular';
  constructor(private themeService: ThemeService) {}
  ngOnInit(): void {
    if (
      window.matchMedia &&
      window.matchMedia('(prefers-color-scheme: dark)').matches
    ) {
      this.themeService.setTheme(AppThemes.DARK);
    } else {
      this.themeService.setTheme(AppThemes.LIGHT);
    }
  }
}
